import _ from 'lodash'

import { createSelector } from 'reselect'
import { MAIN } from '../../../constants/dialogId'
import { RS } from '../../../reducers'
import { botFlowSelector } from './botFlowSelector'

export const mainDialogsSelector = createSelector(
  (state: RS) => botFlowSelector(state)?.mainDialogs, // I <3 PRETTIER
  (mainDialogs = []) => {
    const mainDialog = { id: MAIN, title: 'Main', asMainDialog: true }
    return _.uniqBy([mainDialog, ...mainDialogs], 'id')
  }
)
